<script>

    import {scrollToTop} from "../core/utils.js";

    export let hideScrollToTop = false;
    export let section;

</script>

<style>
    .section-title-container {
        padding: 2rem 0 1.5rem 0;
    }
    .section-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
        font-size: 36px;
        line-height: 1;
        color: var(--accent-color);
        padding: 0;
        margin: 0;
    }
    .section-title small {
        font-size: .8rem;
        color: var(--accent-color);
    }
    .section ~ .section-title {
        padding-top: 1rem;
    }
    .section-subtitle {
        font-family: Roboto, sans-serif;
        font-size: 16px;
        color: var(--secondary-font-color);
    }
</style>

<div class="section-title-container">
    {#if (section.title) }
        <h3 class="section-title">
            <span>{section.title}</span>
            {#if (!hideScrollToTop) }
                <small class="pointer" on:click={() => scrollToTop()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowUp"><path d="M12 20V4"/><path d="M5 11l7-7 7 7"/></svg>
                </small>
            {/if}
        </h3>
    {/if}

    {#if (section.subTitle) }
        <div class="section-subtitle">{ section.subTitle }</div>
    {/if}
</div>

